import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_INPUT_ASSIGNED_BULK_SCHEMA = Object.freeze({
  INPUT_TYPE: '',
  COUNT: 0,
  PER_HOUR: null, // always null for web
  DATE_AND_TIME: null, // always null for web
  NOTES: null, // always null for web
});
const RECORD = generateSchema(TRACKING_INPUT_ASSIGNED_BULK_SCHEMA);
const KEYS: any = generateKeys(TRACKING_INPUT_ASSIGNED_BULK_SCHEMA);

export class InputAssignedBulkTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.input_assigned_bulk;
  }

  get properties() {
    return this.toJS();
  }
}
